import { length as turfLength } from '@turf/turf';
import { type Feature } from 'ol';
import { geoJSONEpsg3857 } from '../../../mapStyleUtils.ts';

/**
 * Calcola la lunghezza di una feature LineString in metri,
 * arrotondata a 2 decimali.
 */
export function getRoundedFeatureLength(feature: Feature): number {
  const geometry = feature.getGeometry();
  if (!geometry) return 0;

  const geomType = geometry.getType();
  if (geomType !== 'LineString' && geomType !== 'MultiLineString') return 0;

  const featureObject = geoJSONEpsg3857.writeFeatureObject(feature);
  const len = turfLength(featureObject, { units: 'meters' });
  return Math.round((len + Number.EPSILON) * 100) / 100;
}
